import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';
import { motion } from 'framer-motion';
import styles from '../Css/SubscriptionScreen.module.css';
import coinsAnimation from '../StaticAnimations/coins.json';

const SubscriptionScreen = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedPack, setSelectedPack] = useState('Daily @ GHC 1.20');

  const handleSubscribe = () => {
    window.location.href = "https://bigcash.gameninja.in/?ani=nzLxEkKr0oMLljs2cZJeKg%3D%3D&gameId=1&serviceId=1";
  };

  const today = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).replace(/\//g, '-');

  const winners = [
    '2332576xx999', '2335451xx399', '2335536xx699', '2332413xx299',
    '2335426xx499', '2335978xx499', '2335431xx999', '2335488xx999',
    '2332571xx111', '2335459xx222', '2335532xx333', '2332418xx444'
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2, delayChildren: 0.1 } }
  };

  const itemUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } }
  };

  return (
    <div className={styles.container}>
      {/* Background Flares */}
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1.5 }}>
        <div className={styles.bgFlare1}></div>
        <div className={styles.bgFlare2}></div>
        <div className={styles.bgFlare3}></div>
      </motion.div>

      {/* Lottie Coin Animations */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        className={styles.lottieContainer}
      >
        <div className={styles.lottieLeft}>
          <Lottie animationData={coinsAnimation} loop={true} speed={0.25} />
        </div>
        <div className={styles.lottieRight}>
          <Lottie animationData={coinsAnimation} loop={true} speed={0.35} />
        </div>
      </motion.div>

      {/* Fixed Navbar */}
      <div className="premium-header-container">
        <motion.header
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="premium-header"
        >
          <motion.img
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            whileHover={{ scale: 1.05, filter: 'drop-shadow(0 10px 25px rgba(253,203,0,0.8))' }}
            src="/assets/images/luckynumberlogo.png"
            alt="Lucky Number Logo"
            className={styles.headerLogo}
          />
          <nav className={styles.navLinks}>
            <Link to="/" className="premium-nav-link">Home</Link>
            <Link to="/faq" className="premium-nav-link">FAQ</Link>
            <Link to="/terms" className="premium-nav-link">Terms</Link>
            <button className={styles.navLoginBtn} onClick={handleSubscribe}>Subscribe</button>
          </nav>
        </motion.header>
      </div>

      {/* Main Grid Layout — padding-top clears the fixed navbar */}
      <motion.div
        className={styles.infoGrid}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Left Side */}
        <div className={styles.heroSection}>
          <motion.div variants={itemUp} className={styles.eyebrow}>
            🏆 Ghana's #1 Lucky Number Game
          </motion.div>
          <motion.h1 variants={itemUp} className={styles.title}>
            Big <span className="text-gold">rewards</span>, every day.<br />Don't miss your <span className="text-gold">chance</span>.
          </motion.h1>
          <motion.p variants={itemUp} className={styles.subtitle}>Every number holds a chance. Yours could be the next one to win big.</motion.p>

          <motion.div variants={itemUp} className={styles.formContainer}>
            <div className={styles.inputGroup}>
              <span className={styles.inputIcon}>📱</span>
              <input
                type="tel"
                className={styles.phoneInput}
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Enter Phone Number"
              />
              <div className={styles.divider}></div>
              <select
                className={styles.packSelect}
                value={selectedPack}
                onChange={(e) => setSelectedPack(e.target.value)}
              >
                <option value="Daily @ GHC 1.20">Daily @ GHC 1.20</option>
                <option value="Weekly @ GHC 5.00">Weekly @ GHC 5.00</option>
                <option value="Monthly @ GHC 15.00">Monthly @ GHC 15.00</option>
              </select>
            </div>
            <button className={styles.subscribeBtn} onClick={handleSubscribe}>
              <span>SUBSCRIBE NOW</span>
              <span className={styles.btnArrow}>→</span>
            </button>
          </motion.div>

          <motion.div variants={itemUp} className={styles.trustBadges}>
            <div className={styles.badge}><span>✅</span> 100% Secure</div>
            <div className={styles.badge}><span>🔔</span> Daily Draw</div>
            <div className={styles.badge}><span>💰</span> Instant Payout</div>
          </motion.div>

          {/* Lucky Number Card */}
          <motion.div variants={itemUp} className={styles.luckyCard}>
            <div className={styles.cardHeader}>Today's Lucky Number</div>
            <div className={styles.dateBadge}>{today}</div>
            <div className={styles.numberDisplay}>
              <span className={styles.maskChar}>X</span>
              <span className={styles.maskChar}>X</span>
              <span className={styles.maskChar}>X</span>
              <span className={styles.maskChar}>X</span>
              <span className={styles.maskChar}>X</span>
              <span className={styles.revealChar}>8</span>
              <span className={styles.revealChar}>8</span>
              <span className={styles.revealChar}>5</span>
              <span className={styles.revealChar}>9</span>
              <span className={styles.revealChar}>9</span>
            </div>
            <p className={styles.cardSubtitle}>Subscribe to reveal your full lucky number</p>
          </motion.div>
        </div>

        {/* Right Side: Winners Image */}
        <div className={styles.rightColumn}>
          <motion.div
            className={styles.winnersImageWrapper}
            initial={{ opacity: 0, x: 60 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.5, delay: 0.4, ease: "easeOut" }}
          >
            <img
              src="/assets/images/winners.webp"
              alt="Winners Celebrating"
              className={styles.winnersBgImage}
            />
            <div className={styles.winnersImageOverlay}></div>
            <div className={styles.floatingBadge}>
              <span className={styles.floatingBadgeCount}>161</span>
              <span className={styles.floatingBadgeLabel}>Winners Today!</span>
            </div>
          </motion.div>
        </div>
      </motion.div>

      {/* Winners Section */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className={styles.winnersSection}
      >
        <h2 className={styles.winnersHeader}>
          {today} Winners <span>(161)</span>
        </h2>
        <div className={styles.winnersList}>
          {winners.map((winner, index) => (
            <motion.span
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05, duration: 0.5 }}
            >
              {winner}
            </motion.span>
          ))}
        </div>

        <p className={styles.footerText}>
          Lucky Number is a fun, chance-based game where you pick a number, test your luck, and discover daily rewards—simple, engaging, and full of excitement. Participate daily to maximize your chances of winning big!
        </p>
      </motion.div>
    </div>
  );
};

export default SubscriptionScreen;
